import { useMemo } from 'react';

import { DossierBodyResponseDto } from 'lib_api/lib/api/gen';

import { UpdateDonnesVehiculeFormValues } from 'types/DonneesVehicule/UpdateDonnesVehiculeFormValues';

function useInitialValues(
  dossier: DossierBodyResponseDto | null | undefined,
): UpdateDonnesVehiculeFormValues {
  return useMemo(() => {
    const etat = dossier?.ficheVehicule?.etat;
    const motifMef = dossier?.ficheInfraction?.motifMef;
    const immatriculation = dossier?.ficheVehicule?.immatriculation;

    return {
      idCorrelationMotifMef: motifMef?.idCorrelation ?? undefined,
      plaqueImmatriculation: immatriculation?.numero ?? undefined,
      sansPlaque: immatriculation?.sansPlaque ?? undefined,
      paysEtranger: immatriculation?.paysEtranger ?? undefined,
      idCorrelationEtatVehicule: etat?.idCorrelation ?? undefined,
      interdictionCirculer: dossier?.interdictionCirculer ?? undefined,
      comment: null,
    };
  }, [dossier]);
}

export default useInitialValues;
